import { create, rawReturn } from 'mutative';
import { isFunction } from '../../utils';
import { LOGOUT_DONE } from '../Auth/constants';
import {
  ACTION_RESOLVED,
  GET_ANSWER,
  GET_ENTITY,
  GET_LIST,
  SAVE_ENTITY,
  UPDATE_ENTITY,
} from './constants';

export const initialState = {
  // Drawer visibility — global so it survives navigation and page changes.
  isDrawerOpen: false,

  // Conversation switcher (past chats for the current business).
  conversations: [],
  conversationsLoading: false,

  // Active conversation.
  conversationId: null,
  messages: [], // { id, role: 'user' | 'assistant', content, error, streaming, tool }
  historyLoading: false,

  // Streaming state for the in-flight answer.
  isStreaming: false,
  activeTool: null, // { name } while a tool_call round is running
  errorMessage: null,

  // Business the drawer is scoped to (context.business_id on /ask).
  businessId: null,
  // All branch/brand ids for businessId — sent on /ask context so analyseit
  // tools get branch_id/brand_id (admin headers often have none).
  branchIds: [],
  brandIds: [],
  scopeLoading: false,

  // Usage meter (GET /v1/kai/usage + terminal SSE usage events).
  usage: null, // { month, questions_used, questions_limit, tokens_used, tokens_limit, enabled }
  usageLoading: false,
  quotaExceeded: false,

  // Generic loader used by the CRUD saga helpers.
  isLoading: false,
};

const reducer = (state = initialState, action) =>
  create(state, draft => {
    // LOGOUT_DONE must fully reset — the v1 bug called initialState.forEach on
    // an object (initialState is not an array), throwing a TypeError on logout.
    if (action.type === LOGOUT_DONE) {
      return rawReturn(initialState);
    }

    const actionParamKeys = Object.keys(action.meta || {});

    switch (action.type) {
      case UPDATE_ENTITY: {
        actionParamKeys.forEach(k => {
          const valOrCb = action.meta[k];
          if (isFunction(valOrCb)) {
            draft[k] = valOrCb(draft[k]);
          } else {
            draft[k] = valOrCb;
          }
        });
        break;
      }

      case GET_ENTITY:
      case GET_LIST:
      case SAVE_ENTITY:
      case GET_ANSWER:
        draft[action.meta?.loaderKey || 'isLoading'] = true;
        break;
      case ACTION_RESOLVED:
        draft[action.meta?.loaderKey || 'isLoading'] = false;
        break;

      default:
        break;
    }

    return draft;
  });

export default reducer;
